import _ from 'lodash/fp'
import React from 'react'
import axios from 'axios'
import {viewRecord, downloadRecord, RecordClass} from '../utils'
import { processAllFiles } from './processAllFiles'
import {getFileList} from '../utils/fileEventToList'
import {EventLogStatus} from '../utils/recordEnums'
import {appendLog} from './uploadLog'

export const UploaderAction = {
  Retry: ({ recordManager, uploader }, record) => {
    recordManager.queueToRetry(record)
    uploader.start()
  },

  View: (utils, record) => {
    viewRecord(record)
  },
  Download: async ({ recordManager }, record) => {
    recordManager.updateRecord(record, _.set('preparingDownload', true))
    try {
      await downloadRecord(record)
    } catch (e) {
      alert('fail')
    }
    recordManager.updateRecord(record, _.unset('preparingDownload'))
  },

  Delete: async ({ recordManager, uploader }, record) => {
    try {
      recordManager.updateRecord(record, _.set('deleting', true))
      const recordUID = await uploader.cancelRecord(record.key)
      if (recordUID || record.recordUID) {
        await axios.delete(`/record/${recordUID || record.recordUID}`)
      }
      recordManager.removeRecord(record)
    } catch (e) {
      console.log(e)
      recordManager.updateRecord(record, _.set('deleting', false))
      // TODO
    }
  },
  Pause: async ({ recordManager, uploader }, record) => {
    await recordManager.pauseRecord(record.key)
    await uploader.cancelRecord(record.key)
  },
  ConfirmDelete: ({ recordManager }, record) => {
    recordManager.updateRecord(record, _.set('confirmingDelete', true))
  },
  CancelDelete: ({ recordManager }, record) => {
    recordManager.updateRecord(record, _.set('confirmingDelete', false))
  },

  CloseDetailsDialog: ({ setData }, record) => {
    setData(_.set('detailsDialog', false))
  },
  ShowDetailsDialog: async ({ setData, recordManager }, record) => {
    const queuedRecord = recordManager.getRecentlyQuarantinedRecord(record)
    if (queuedRecord) {
      const allFiles = _.uniqBy('file', [
        ...queuedRecord.uploaded,
        ...queuedRecord.files,
        ...queuedRecord.uploading,
      ])
      setData(
        _.set('detailsDialog', {
          ...queuedRecord,
          files: allFiles.map(({ file }) => ({
            name: file.name,
            isHarmful: _.find(['file', file], queuedRecord.quarantined),
          })),
        })
      )
    } else {
      setData(_.set('detailsDialog', { ...record, files: [] }))
      const { data } = await axios.get(`/record/${record.recordUID}/quarantine`)
      setData(
        _.set('detailsDialog', {
          ...record,
          files: data.map(({ originalFilename }) => ({
            name: originalFilename,
            isHarmful: true,
          })),
        })
      )
    }
  },

  Upload: async ({ setData, recordManager, uploader, ...utils }, files) => {
    let allErrors = []
    appendLog(files,EventLogStatus.Waiting)
    /* eslint-disable no-restricted-syntax */
    for await (const [records, discarded, errors] of processAllFiles(files,[RecordClass.Radiology])) {
      // console.log({records,discarded})
      if (records?.length) {
        recordManager.insertMany(records)
        await utils.resolveJwt()
        uploader.start()
      }
      if (errors?.length) {
        allErrors = allErrors.concat(errors)
      }
      setData(_.update('discarded', (v = []) => v.concat(discarded)))
      appendLog(discarded || [], EventLogStatus.Discarded)
    }
    setData(_.update('isProcessing', i => i - 1))
  },
  UploadFromEvent: async (utils,e) => {
    utils.setData(_.flow(
      _.update('activated',(i=0) => i + 1),
      _.update('isProcessing', i => i + 1)
    ))
    const files = await getFileList(e)
    return UploaderAction.Upload(utils,files)
  },
  GetFilesForRecord: ({ recordManager}, recordKey) => {

    const {files = [],uploading = [],uploaded = [],failed = [], paused = []} =recordManager.getQueuedRecord(recordKey)
    return [...files,...uploading,...uploaded,...failed,...paused].map(_.get('file'))
  },
  Deactivate: (utils,lastActivated) => {
    utils.setData(_.update('activated',(currentActivated) => lastActivated !== currentActivated ? currentActivated : 0))
  }
}
